<template>
  <div id="return-policy-container">
    <div>
      <section>
        <div
          class="title-box"
          :class="[isReturnPolicy ? 'is-orange' : 'is-grey']"
        >
          <h1 class="title" @click="generatedPdfPolicy()">
            Política de devolução
          </h1>
        </div>
      </section>
      <section>
        <div
          class="title-box"
          :class="[isGeneralInformationVisible ? 'is-orange' : 'is-grey']"
        >
          <h1 class="title" @click="toggleGeneralInfoVisibility()">
            Instruções Gerais
          </h1>
        </div>
        <p v-show="isGeneralInformationVisible">
          <video width="100%" controls>
            <source
              src="https://storage.googleapis.com/tutorial-video/TUTORIAL%20PORTAL%20DEVOLU%C3%87%C3%95ES_v05.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </p>
      </section>
      <section>
        <Faq />
      </section>
    </div>
  </div>
</template>

<script>
import Faq from "@/components/home/return-policy/FAQ.vue";
import ServicePolicy  from '@/services/polity-service/polity-service.js';
import { EventBus } from "@/eventHub";

//reserved for future code
export default {
  name: "ReturnPolicy",
  components: {
    Faq
  },
  data: function() {
    return {
      isGeneralInformationVisible: false,
      isReturnPolicy: false
    };
  },
  methods: {
    toggleGeneralInfoVisibility() {
      this.isGeneralInformationVisible = !this.isGeneralInformationVisible;
    },

    generatedPdfPolicy() {
      EventBus.$emit("showPreLoader");
      ServicePolicy.getPolicyFile().then(({ data }) => {
          const base64 = data.url.split(";");
          console.log("sddad")
          console.log(base64);
          const format = base64[0].split("/");
          EventBus.$emit("hidePreLoader");
          if (format[1] === "pdf") {
            const iframe = `
        <iframe src='${data.url}' height='100%' width='100%'></iframe>
        `;
            const w = window.open("", "", "width=auto,height=auto");
            w.document.write(iframe);
           //window.open("", "", "width=auto,height=auto");
          } else {
            const iframe = `
          <div style="heigth=100%; width=100%;">
            <img src=${data.url} alt="No image">
          </div>
        `;
        const w = window.open("", "", "width=auto,height=auto");
            w.document.write(iframe);
           window.open("", "", "width=auto,height=auto");
          }
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

#return-policy-container {
  display: flex;
  align-self: center;
  justify-content: center;
  align-items: flex-start;
  width: 53.75%;
  min-height: 400px;

  div {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;

    section {
      width: 100%;

      .title-box {
        border-left: 4px solid $grey2;
        border-bottom: 1px solid $grey4;
        padding: 0 0 2px 5px;
        margin-top: 30px;

        .title {
          margin: 0;
          font-weight: 500;
          cursor: pointer;
        }

        &:hover {
          border-left-color: $orange1;
        }
      }

      .is-orange {
        border-left-color: $orange1;
      }

      .is-grey {
        // border-left-color: $grey2;
        background-color: #9e9e9e;
      }
    }
  }
}
</style>
